import clsx from "clsx";
import { WorkflowServiceIcon } from '../Common/WorkflowServiceIcon';
type AddIntegrationProps = {
    workflowType: string;
    isIntegrationPresent: boolean;
    customFetch: (url: string) => Promise<Response>;
    workflowId: string;
    workflowNode: any;
    chosenAction: string;
}

export const onNewAccountClick = (
    workflowType: string,
    customFetch: (url: string) => Promise<Response>,
    workflowId: string,
    workflowNode: any,
    chosenAction: string
) => {
    let url = `/v1/${workflowType}/login`;
    let responseKey = 'redirectUrl';
    console.log("workflowType", workflowType);
    console.log("chosenAction", chosenAction);
    if (workflowType === 'gmail' && chosenAction === 'ListenNewEmail') {
        url = '/v1/nylas/login';
        responseKey = 'auth_url';
    }
    if (workflowNode?.node?.id && workflowNode?.node?.id !== "") {
        url += `?nodeId=${workflowNode.node.id}`;
    }
    customFetch(url).then(response => {
        if (response.status === 200) {
            response.json().then(data => {
                localStorage.setItem("workflowId", workflowId);
                workflowNode.node.id && localStorage.setItem(
                    "nodeId", workflowNode.node.id);
                window.location.href = data[responseKey];
            })
        }
    }).catch(error => {
        console.error("Error fetching login URL:", error);
    });
}

const AddIntegration = ({
    workflowType,
    isIntegrationPresent,
    customFetch,
    workflowId,
    workflowNode,
    chosenAction
}: AddIntegrationProps) => {
    var url = `/v1/${workflowType}/login`;
    if(workflowNode?.node?.id && workflowNode?.node?.id !== "") {
        url += `?nodeId=${workflowNode.node.id}`;
    }
    return (
        <>
            <div className="text-xs text-greyishBlue">Connect {workflowType} to fetch records. Your encrypted credentials can be removed anytime. Only you can access this connection.</div>
                <div
                    className={clsx("mt-2 w-full flex items-center p-2 border border-solid border-[#AAB6FF] rounded", { "cursor-pointer": !isIntegrationPresent })}
                        onClick={() => {
                            onNewAccountClick(workflowType, customFetch, workflowId, workflowNode, chosenAction);
                        }}
                >
                    <WorkflowServiceIcon
                        workflowType={workflowType}
                        alt={workflowType}
                        height={28}
                        width={28}
                    />
                    <div className="flex-1 text-center text-xs text-nanonetsBlue font-medium">
                        {
                            isIntegrationPresent ?
                                `Your ${workflowType} account is connected`
                                : `Connect your ${workflowType} account`
                        }
                    </div>
            </div>
        </>
    )
};

export default AddIntegration;